import { render, staticRenderFns } from "./DeviceBatchClear.vue?vue&type=template&id=4a15c444&scoped=true&"
import script from "./DeviceBatchClear.vue?vue&type=script&lang=js&"
export * from "./DeviceBatchClear.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBatchClear.vue?vue&type=style&index=0&id=4a15c444&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15c444",
  null
  
)

export default component.exports